module.exports = __webpack_public_path__ + "img/cj_2@2x.5e04705b.png";